import React from "react";
import { Select, Typography } from "@material-ui/core";

const InputSelect = (props) => {
  return (
    <Select
      value={props.value}
      style={{ width: "99%" }}
      onChange={(e) => props.Change_Data(props.data_key, e.target.value)}
      list={props.list}
    >
      {props.list.map((item, index) => {
        const { name, value } = item;
        return (
          <option
            value={value}
            key={index}
            style={{
              fontSize: "130%",
              //borderBottom: "grey solid 1px",
              //borderTop: "grey solid 1px",
            }}
          >
            {name}
          </option>
        );
      })}
    </Select>
  );
};

export default InputSelect;
